/* InputTextEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;

class InputTextEditor extends CommonEditor {
    constructor(options) {
        super(options);
        const placeHolderText = options.item.dheading;
        if (placeHolderText) {
            this.input.placeholder = placeHolderText;
        }
    }

    _createInput() {
        return new InputTextControl({
            darkTheme: false
        });
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = InputTextEditor;
